const colorCls = "_n29c16qpqz";
const colorTransparencyDisallowedCls = "_n29c16j60cf";
const colorTransparencyAllowedCls = "_n29c1hs4no3";
const button = "_n29b185r8n1";

export { button, colorCls, colorTransparencyAllowedCls, colorTransparencyDisallowedCls };
import "./Color.style.linaria.module.css";
//# sourceMappingURL=Color.style.js.map
